import React from 'react';
import './ShowcaseHeader.css';

import { FaList } from 'react-icons/fa';
import { BsFillGrid3X3GapFill } from 'react-icons/bs';

import { Link } from 'react-router-dom';
import Select from 'react-select';

// Base sorting options
let baseSorting = [
  { value: '', label: 'default', isDisabled: true },
  { value: 'featured', label: 'featured' },
  { value: 'lowPrice', label: 'low price' },
  { value: 'highPrice', label: 'high price' }
];

const ShowcaseHeader = ({ showing, total, sortOption, handleSort, isCar }) => {
// Create a fresh sorting array inside the component
const sorting = isCar 
  ? [...baseSorting.slice(0, 2), { value: 'latest', label: 'latest' }, ...baseSorting.slice(2)]
  : [...baseSorting]; // Keep original sorting for non-car pages

  // Determine correct links based on the type (shop or cars)
  const gridLink = isCar ? '/Car-Grid' : '/Shop-grid';
  const listLink = isCar ? '/Car-List' : '/Shop-list';

  // Find the selected sorting option
  const selectedOption = sorting.find((option) => option.value === sortOption);

  return (
    <div className='showcase'>
      <div className='showing'>showing {showing} of {total} {isCar ? 'cars' : 'products'}</div>

      <div className='styles'>
        <Link to={gridLink}><BsFillGrid3X3GapFill /></Link>
        <Link to={listLink}><FaList /></Link>
      </div>

      <Select
        options={sorting}
        value={selectedOption}
        onChange={handleSort}
        isSearchable={false}
        className="custom-select sorting box"
        classNamePrefix="custom-select-prefix"
      />
    </div>
  );
}

export default ShowcaseHeader;